import { render } from "./AssignmentManager.vue?vue&type=template&id=3ebc5294&scoped=true"
import script from "./AssignmentManager.vue?vue&type=script&lang=js"
export * from "./AssignmentManager.vue?vue&type=script&lang=js"

import "./AssignmentManager.vue?vue&type=style&index=0&id=3ebc5294&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebc5294"]])

export default __exports__